import { BaseApiResponseModel } from '../../core/abstractions/base-api-response.model';
import { ApiRequestModel } from './api-request.model';
import { RelatedItemModel } from './related-item.model';

export class ApiResponseModel<T> extends BaseApiResponseModel {
    type: string;
    page?: number;
    pageSize?: number;
    totalPages?: number;
    totalRecords?: number;
    value: T;
    contentTitle: string;
    actions: ApiRequestModel[];
    relatedResources: RelatedItemModel[];
    relatedActions: RelatedItemModel[];

    constructor(init?: Partial<ApiResponseModel<T>>) {
        super();

        if (!!init) {
            Object.assign(this, init);
        }
    }
}
